import React, { useEffect, useState, useRef, useCallback } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography, Card, CardContent, Button, CircularProgress, Stack, Grid } from '@mui/material';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import SearchIcon from '@mui/icons-material/Search';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import FilterListIcon from '@mui/icons-material/FilterList';
import LeadService from '../../../core/services/leadsService';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PinDropIcon from '@mui/icons-material/PinDrop';
import toast from 'react-hot-toast';
import EmailIcon from '@mui/icons-material/Email';
import { OPEN_LEAD_COM_MODEL, OPEN_LEAD_MODEL } from '../../../core/store/slice/icaSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import Autocomplete from '@mui/material/Autocomplete';
import Pagination from '@mui/material/Pagination';
import { debounce, throttle } from 'lodash';
import ScrollAnimation from 'react-animate-on-scroll';
import CheckIcon from '@mui/icons-material/Check';
import Menu from '@mui/material/Menu';
const ICASearch = () => {
    const navigate = useNavigate();
    const [status, setStatus] = React.useState(null);
    const [icaAgentData, setIcaAgentData] = React.useState([]);
    const [agentData, setAgentData] = React.useState([]);
    const [agent, setAgent] = React.useState(null);
    const [icaAgent, setIcaAgent] = React.useState(null);
    const [name, setName] = React.useState('');
    const [phoneNo, setPhoneNo] = React.useState('');
    const [date, setDate] = React.useState('');
    const [data1, setData1] = React.useState([]);
    const [allLeadData, setAllLeadData] = useState([]);
    const [storeData, setStoreData] = useState();
    const [loading, setLoading] = React.useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [value, setValue] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [sortOrder, setSortOrder] = useState('asc');
    const [menuAnchor, setMenuAnchor] = useState(null);

    const abortControllerRef = useRef(null);

    const dispatch = useDispatch();

    const clearState = () => {
        setStatus(null);
        setIcaAgent(null);
        setAgent(null);
        setName('');
        setPhoneNo('');
        setDate('');
        getAllSearchLeads(1);
    };

    function formatDate(inputDate) {
        const date = new Date(inputDate);

        if (isNaN(date.getTime())) {
            return '';
        } else {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        }
    }

    function isAnyValueAvailable() {
        const obj = {
            isa_search: icaAgent,
            status_search: status,
            customer_name: name,
            customer_phone: phoneNo,
            agent_search: agent,
            created_at: date,
        };
        for (const key in obj) {
            if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
                return true;
            }
        }
        return false;
    }

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };
        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '#fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };

    const submit = async () => {
        const dataToSend = {
            isa_search: icaAgent,
            status_search: status,
            customer_name: name,
            customer_phone: phoneNo,
            agent_search: agent,
            created_at: formatDate(date),
        };
        setCurrentPage(1);
        setStoreData(dataToSend);
    };

    const getAllSearchLeads = async (
        storeData = { isa_search: '', status_search: '', customer_name: '', customer_phone: '', agent_search: '', created_at: '' },
        currentPage
    ) => {
        try {
            setLoading(true);
            const res = await LeadService.searchLeads(storeData, currentPage);
            if (res.data.success) {
                setAllLeadData(res?.data?.data?.data);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 0) / (res?.data?.data?.per_page || 1)));
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    const throttledAllSearchLeads = useCallback(
        throttle((storeData, currentPage, signal) => {
            getAllSearchLeads(storeData, currentPage, signal);
        }, 2000),
        []
    );

    const fetchAllSearchLeads = useCallback(
        debounce((storeData, currentPage) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledAllSearchLeads(storeData, currentPage, abortController.signal);
        }, 300),
        [throttledAllSearchLeads]
    );

    useEffect(() => {
        fetchAllSearchLeads(storeData, currentPage);
    }, [storeData, currentPage]);

    const getData = async () => {
        try {
            const res = await LeadService.getallIsa();
            if (res?.data?.success) {
                setIcaAgentData(res?.data?.isa_agents);
                setAgentData(res?.data?.agents);
                return;
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };
    const OptionsAgentData = agentData?.map((agent) => ({
        id: agent?.id,
        text: `${agent?.name} ${agent?.last_name}`, // Display text combining name and last name
    }));

    const optionsIcaAgentData = icaAgentData?.map((data) => ({
        id: data?.id,
        text: `${data?.name} ${data?.last_name}`, // Display text combining name and last name
    }));

    const displayStatus = [
        {
            label: 'Appointment Set',
            value: 'appointment_set',
        },
        {
            label: 'New',
            value: 'active',
        },
        {
            label: 'Spoke with Customer',
            value: 'spoke_with_customer',
        },
        {
            label: 'BAMFAM',
            value: 'bamfam',
        },
        {
            label: 'Nurture Before Sale',
            value: 'nurture',
        },
        {
            label: 'Sale Closed',
            value: 'closed',
        },
        {
            label: 'Nurture After Sale',
            value: 'nurture_after_sale',
        },
        {
            label: 'Rejected',
            value: 'rejected',
        },
        {
            label: 'Showing Homes',
            value: 'showing_homes',
        },
        {
            label: 'Submitting Offers',
            value: 'submitting_offers',
        },
        {
            label: 'Under Contract',
            value: 'under_contract_escrow',
        },
        {
            label: 'Met with customer',
            value: 'met_with_customer',
        },
        {
            label: 'Follow Up',
            value: 'follow_up',
        },
        {
            label: 'Buy Side Contract',
            value: 'buy_side_contract',
        },
        {
            label: 'List Under Contract',
            value: 'list_under_contract',
        },
        {
            label: 'Listing Signed',
            value: 'listing_signed',
        },
        {
            label: 'Listing Appointment',
            value: 'listing_appointment',
        },
        {
            label: 'Valuation Appointment',
            value: 'valuation_appointment',
        },
        {
            label: 'Buyer Broker Signed',
            value: 'buyer_broker_signed',
        },
        {
            label: 'DNC',
            value: 'dnc',
        },
        {
            label: 'Agent',
            value: 'agent',
        },
        {
            label: 'Not Interested',
            value: 'not_interested',
        },
    ];

    useEffect(() => {
        getData();
    }, []);

    const sortByAscending = () => {
        const sortedData = [...allLeadData].sort((a, b) => a.first_name.localeCompare(b.first_name));
        setAllLeadData(sortedData);
        setSortOrder('asc');
    };

    const sortByDescending = () => {
        const sortedData = [...allLeadData].sort((a, b) => b.first_name.localeCompare(a.first_name));
        setAllLeadData(sortedData);
        setSortOrder('desc');
    };
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box style={{ display: 'grid' }}>
                    <Card
                        sx={{
                            transform: 'scale(1)',
                            transition: 'transform 0.3s ease-in-out',
                            borderRadius: '16px',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                            padding: '16px',
                            backgroundColor: '#fafafa',
                            height: '280px',
                            position: 'relative',
                            overflow: 'visible',
                        }}
                    >
                        <Box style={{ display: 'flex', gap: '5px' }}>
                            <Box>
                                <Autocomplete
                                    value={displayStatus?.find((option) => option.value === status) || null}
                                    getOptionLabel={(option) => option?.label} // Show the label in the dropdown
                                    onChange={(event, newValue) => {
                                        setStatus(newValue ? newValue?.value : '');
                                    }}
                                    options={displayStatus}
                                    renderInput={(params) => <TextField {...params} label="Status" />}
                                    sx={{
                                        width: 300,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>
                            <Box>
                                <Autocomplete
                                    value={optionsIcaAgentData?.find((option) => option.id === icaAgent) || null}
                                    onChange={(event, newValue) => setIcaAgent(newValue?.id || null)}
                                    options={optionsIcaAgentData || []}
                                    getOptionLabel={(option) => option.text}
                                    renderInput={(params) => <TextField {...params} label="Select ICA Agent" />}
                                    disabled={false}
                                    sx={{
                                        width: 300,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>
                            <Box style={{ display: 'flex' }}>
                                <Autocomplete
                                    value={OptionsAgentData?.find((option) => option.id === agent) || null}
                                    onChange={(event, newValue) => setAgent(newValue?.id || null)}
                                    options={OptionsAgentData || []}
                                    getOptionLabel={(option) => option.text}
                                    renderInput={(params) => <TextField {...params} label="Select RE Agent" />}
                                    disabled={false}
                                    sx={{
                                        width: 300,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                        {/*ICA Agent and PA Agent */}

                        <Box style={{ display: 'flex', marginTop: '16px', gap: '5px' }}>
                            <div style={{ marginTop: '10px' }}>
                                <TextField
                                    multiline
                                    placeholder="Type Customer Name"
                                    name="name"
                                    value={name}
                                    type="text"
                                    onChange={(e) => setName(e.target.value)}
                                    sx={{
                                        width: 300,
                                        fontSize: '10px',
                                        color: '#6E757C',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <TextField
                                    multiline
                                    placeholder="Type Customer Phone Number"
                                    name="phoneNo"
                                    value={phoneNo}
                                    type="number"
                                    onChange={(e) => setPhoneNo(e.target.value)}
                                    sx={{
                                        width: 300,
                                        fontSize: '10px',
                                        color: '#6E757C',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                            <div>
                                <TextField
                                    margin="dense"
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        width: 300,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                        </Box>

                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            {/* search */}
                            <Box
                                style={{
                                    width: '66px',
                                    height: '60px',
                                    background: '#336a93',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    marginTop: '6px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                onClick={submit}
                            >
                                {loading ? (
                                    <CircularProgress sx={{ color: 'white' }} />
                                ) : (
                                    <SearchIcon
                                        onClick={submit}
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '41px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </Box>

                            {/* filter */}
                            <Box
                                style={{
                                    width: '66px',
                                    height: '60px',
                                    background: '#336a93',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    marginTop: '6px',
                                }}
                            >
                                <Box position={'relative'}>
                                    <FilterListIcon
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '41px',
                                        }}
                                        onClick={(e) => setMenuAnchor(e.currentTarget)}
                                    />
                                    <Menu
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        anchorEl={menuAnchor}
                                        open={Boolean(menuAnchor)}
                                        onClose={() => setMenuAnchor(null)}
                                    >
                                        <MenuItem onClick={sortByAscending}>
                                            Ascending
                                            {sortOrder === 'asc' ? (
                                                <>
                                                    <CheckIcon />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </MenuItem>
                                        <MenuItem onClick={sortByDescending}>
                                            Descending
                                            {sortOrder === 'desc' ? (
                                                <>
                                                    <CheckIcon />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </MenuItem>
                                    </Menu>
                                </Box>
                            </Box>

                            <div style={{ marginTop: '20px' }}>
                                <Button
                                    style={{
                                        width: '60px',
                                        border: '1px solid gray',
                                        background: '#bababa',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        marginLeft: '5px',
                                        cursor: 'pointer',
                                        color: 'black',
                                    }}
                                    sx={{ fontFamily: 'inherit' }}
                                    onClick={clearState}
                                >
                                    clear
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Box>
            </Box>

            {/* <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}> */}
            {/* <Box boxShadow={4} p={1} sx={{ mb: 1, mt: 1, borderRadius: '12px' }}> */}
            {allLeadData?.length === 0 ? (
                <Typography fontWeight="bold" textAlign="center">
                    No data found!
                </Typography>
            ) : (
                <Grid container spacing={1}>
                    {allLeadData?.map((item, index) => {
                        const { formattedStatus, divStyle } = mapStatusToFormatAndColor(item.status);
                        const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
                            const date = new Date(dateString);
                            const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
                            utcDate.setHours(utcDate.getHours() + offsetInHours);
                            return utcDate;
                        };

                        const getUserOffset = () => {
                            const offset = localStorage.getItem('userOffset');
                            return offset ? parseFloat(offset) : 0;
                        };

                        const formatDateTime = (date) => {
                            const options = {
                                year: 'numeric',
                                month: 'long',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            };
                            return date.toLocaleDateString(undefined, options).replace(',', '');
                        };

                        const userOffset = getUserOffset();
                        const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(item?.created_at, userOffset);
                        const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';

                        return (
                            <Grid item key={item.id} xs={12} sm={6} md={4} lg={4} xl={3} sx={{ marginTop: '12px' }} spacing={1}>
                                <Card
                                    variant="outlined"
                                    sx={{
                                        mb: 1,
                                        mt: 1,
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        cursor: 'pointer',
                                        transform: 'scale(1)', // Initial scale
                                        transition: 'transform 0.3s ease-in-out', // Transition for smooth scaling
                                        width: '100%', // Make sure it adapts inside the Grid item
                                        maxWidth: {
                                            xs: '100%', // Full width on extra small screens
                                            sm: '400px', // Set specific width for small screens
                                            md: '450px', // Medium screens
                                            lg: '500px', // Large screens
                                            xl: '550px', // Extra-large screens
                                        },
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')} // Slight zoom on hover
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')} // Revert to original scale
                                    onClick={() => {
                                        navigate('/get-leads');
                                        dispatch(OPEN_LEAD_COM_MODEL(item?.id));
                                    }}
                                >
                                    <CardContent>
                                        <Box>
                                            <Grid container spacing={1}>
                                                {/* Image Section */}
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Box position="relative">
                                                        <img
                                                            src={`https://maps.googleapis.com/maps/api/staticmap?zoom=10&size=371x190&maptype=roadmap&center=${item?.buyer_latitude},${item?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                            alt="Static map"
                                                            style={{
                                                                borderRadius: '15px',
                                                                width: '100%',
                                                                height: '170px',
                                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                            }}
                                                        />
                                                        <Box
                                                            position="absolute"
                                                            top="50%"
                                                            left="50%"
                                                            transform="translate(-50%, -50%)"
                                                            zIndex={10}
                                                            display="flex"
                                                            alignItems="center"
                                                            borderRadius="50%"
                                                            p={1}
                                                            sx={{ backgroundColor: 'white' }}
                                                        >
                                                            <img
                                                                src={logo_between}
                                                                alt=""
                                                                style={{
                                                                    width: '30px',
                                                                    height: '30px',
                                                                    borderRadius: '50%',
                                                                    border: '1px solid gray',
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Grid>

                                                {/* Details Section */}
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Box>
                                                        <Typography variant="h6" color="textSecondary" gutterBottom fontWeight="bold">
                                                            {item.first_name} {item.last_name}
                                                        </Typography>

                                                        <Stack spacing={1} direction="row" alignItems="center">
                                                            <PinDropIcon />
                                                            <Typography variant="subtitle2" color="textSecondary" sx={{ wordBreak: 'break-word' }}>
                                                                {item?.display_address || 'N/A'}
                                                            </Typography>
                                                        </Stack>

                                                        <Stack spacing={1} direction="row" alignItems="center">
                                                            <EmailIcon />
                                                            <Typography variant="subtitle2" color="textSecondary" sx={{ wordBreak: 'break-word' }}>
                                                                {item?.email}
                                                            </Typography>
                                                        </Stack>

                                                        <Stack spacing={1} direction="row" alignItems="center">
                                                            <CalendarMonthIcon />
                                                            <Typography variant="subtitle2" color="textSecondary">
                                                                {formattedDate}
                                                            </Typography>
                                                        </Stack>

                                                        <Box mt={2}>
                                                            <Button
                                                                style={{
                                                                    ...divStyle,
                                                                    borderRadius: '10px',
                                                                    padding: '2px',
                                                                }}
                                                            >
                                                                {formattedStatus}
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            )}
            {/* </Box> */}
            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                <Pagination count={totalPages} color="primary" page={currentPage} onChange={(event, value) => setCurrentPage(value)} />
            </Box>

            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
            {/* </Box> */}
        </div>
    );
};
export default ICASearch;
